import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  clearTourSealNumberDetails,
  getTourSealNumber,
} from "../redux/actions/tourActions";
import { Button, Form, Input, Space } from "antd";
import queryString from "query-string";
import SealedValueTable from "./sealedValueTable/SealedValueTable";

const { TextArea } = Input;
const layout = {
  style: { margin: "24px" },
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const RiderContent = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [enableTable, setEnableTable] = useState(false);
  const [tourDetails, setTourDetails] = useState({});

  const tourSealNumber = useSelector(
    (state) => state?.tourSealNumber?.allSealNumber
  );
  const { authToken, clientId, tourId } = queryString.parse(location.search);

  const hasFetchedData = useRef(false);

  const handleError = useCallback(
    (error = {}) => {
      const { message = "", data = {} } = error;
      navigate(`/error-fallback${location.search}`, {
        state: { from: location, message, data },
      });
    },
    [navigate, location]
  );

  const fetchTourSealNumber = useCallback(() => {
    if (hasFetchedData.current) return;

    const authParams = {
      authToken,
      clientId,
      tourId: tourId,
    };

    dispatch(clearTourSealNumberDetails());

    dispatch(
      getTourSealNumber(
        authParams,
        true,
        navigate,
        handleError,
        (finishStatus) => {
          if (finishStatus.status === "success") {
            hasFetchedData.current = true;
          }
        }
      )
    );
  }, [authToken, clientId, dispatch, handleError, navigate, tourId]);

  useEffect(() => {
    if (tourId && !hasFetchedData.current) {
      fetchTourSealNumber();
    }
  }, [fetchTourSealNumber, tourId]);

  useEffect(() => {
    if (tourSealNumber && Object.keys(tourSealNumber).length > 0) {
      setTourDetails(tourSealNumber);
      setEnableTable(true);
    }
  }, [tourSealNumber]);

  const onFinish = () => {
    hasFetchedData.current = false;
    fetchTourSealNumber();
  };

  return (
    <>
      <Form
        {...layout}
        form={form}
        name="input-page"
        size="middle"
        onFinish={onFinish}
      >
        <Form.Item shouldUpdate label="Tour Id" name="tourId">
          <Space size="middle">
            <TextArea value={tourId} autoSize disabled />
          </Space>
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            Refresh
          </Button>
        </Form.Item>
      </Form>
      {enableTable && (
        <SealedValueTable
          tourDetails={tourDetails}
          isRider={true}
          handleError={handleError}
          clientId={clientId}
          authToken={authToken}
          setEnableTable={setEnableTable}
        />
      )}
    </>
  );
};

export default RiderContent;
